import { LayerWrapper } from './LayerWrapper';
import Feature from 'ol/Feature';
import * as olStyle from 'ol/style';
import { Events } from '@shared/Events';


/**
 * @author NikolaV
 */
export class SelectedFeatureHighlightLayer extends LayerWrapper<Feature> {
    constructor(opts) {
        super(opts);
        Events.on('map-highlight-clear', (e, feature: any) => {
            this.clear()
        });

        Events.on('map-highlight-feature', (e, feature: any) => {
            SelectedFeatureHighlightFactory.setActiveStyle(styles.normal);
            const old = this.layerSource.getFeatures().filter(Boolean);
            this.clear();
            this.drawOne(feature)
            if (old?.length) {
                old.filter(c => c.get('data')?.id !== feature.get('data')?.id).forEach(f => {
                    f.setStyle(SelectedFeatureHighlightFactory.styles.secondary);
                    this.layerSource.addFeature(f);
                })
            }
        });
    }
}


const styles = {
    normal: new olStyle.Style({
        image: new olStyle.Circle({
            radius: 21,
            fill: new olStyle.Fill({
                color: [71, 151, 204, 0.9]
            })
        }),
        stroke: new olStyle.Stroke({
            color: [255, 255, 255, 0.8],
            width: 30
        })
    }),
    secondary: new olStyle.Style({
        image: new olStyle.Circle({
            radius: 15,
            fill: new olStyle.Fill({
                color: [71, 151, 204, 0.5]
            })
        })
    })
};

let activeStyle = styles.normal;

export const SelectedFeatureHighlightFactory = {
    setActiveStyle(s) {
        activeStyle = s;
    },

    makeFeatures(feature: Feature) {
        if (!feature) return;

        const f = feature.clone();
        f.setStyle(activeStyle);

        return f;
    },

    styleFunction(feature: Feature) {
        return [activeStyle];
    },

    styles
};
